<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="banner-btm">
          <div class="text-center py-5 container">
            <h1 v-html="$t('Home.BannerTitle')" class="mt-3 mb-2 yellow-col"></h1>
            <div class="mb-4"><img
                src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/walmart-icon.png"
                alt="Walmart Logo" width="300"></div>
            <p class="text-center mb-4 banner-desc h2" v-html="$t('Home.BannerDesc')"></p>
            <div class="mb-4"><img
                src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/walmart-icon-sq.png"
                alt="" aria-hidden="true"></div>

            <div class="readytosubmit mt-5">
              <h2 class="mb-4 fw-bold" v-html="$t('Home.ReadytoSubmitTitle')"></h2>
              <p class="mb-4" v-html="$t('Home.ReadytoSubmitDesc')"></p>
              <div class="row d-flex justify-content-center">
                <div class="col-sm-12 text-center">
                  <router-link :to="{ name: 'Upload' }" class="btn btn-link mb-4" :aria-label="$t('Home.GetStartedBtn')">
                    {{ $t('Home.GetStartedBtn') }}
                  </router-link>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-12">
                  <small v-html="$t('Home.ParticipatingProductLink')" @click="handleLinkClick"></small>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <small v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="how-to-blk">
          <div class="container">
            <h2 class="text-center mb-5 fw-bold">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center mb-md-5 mb-4 d-flex justify-content-center">
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/shop.png"
                    alt="" aria-hidden="true" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.ShopTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/snap.png"
                    alt="" aria-hidden="true" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.SnapTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/register.png"
                    alt="" aria-hidden="true" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.SendTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/confirm.png"
                    alt="" aria-hidden="true" class="img-fluid mb-3" />
                  <h3>{{ $t('Home.RegisterTitle') }}</h3>
                  <p>
                    <small v-html="$t('Home.RegisterDetail')"></small>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-3 mb-5 pb-5">
                <small v-html="$t('Home.HowToParticipateDisclaimer')"></small>
              </div>
            </div>
          </div>
        </div>


      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    // New method: make <a> behave like router-links
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1); // e.g. 'FAQ' from '/FAQ'

          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              // Fallback if route name doesn't exist
              this.$router.push(href);
            });
          }
        }
      }
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 575px) {}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
